import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const WarningIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17ZM11.25 14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14L12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7L11.25 14Z"
      fill={props.color}
    />
  </svg>
)

export const WarningHexagonalIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="17" r="1" transform="rotate(-180 12 17)" fill={props.color} />
    <path
      d="M12 14L12 6.99997M3 9.13192V14.8681C3 16.3914 3.7923 17.799 5.07846 18.5607L9.92154 21.4288C11.2077 22.1904 12.7923 22.1904 14.0785 21.4288L18.9215 18.5607C20.2077 17.799 21 16.3914 21 14.8681V9.13192C21 7.6086 20.2077 6.20099 18.9215 5.43932L14.0785 2.57125C12.7923 1.80958 11.2077 1.80958 9.92154 2.57125L5.07846 5.43932C3.7923 6.20099 3 7.6086 3 9.13192Z"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export const WarningTriangleIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="52" height="46" viewBox="0 0 52 46" fill="none" {...props}>
    <path
      d="M30.6108 14.5853C30.8027 14.2494 31.2871 14.2494 31.479 14.5853L48.0327 43.5542C48.2232 43.8875 47.9825 44.3022 47.5986 44.3022H14.4913C14.1074 44.3022 13.8667 43.8875 14.0572 43.5542L30.6108 14.5853Z"
      fill="#B0D717"
      stroke="#133C40"
      strokeWidth="3"
    />
    <mask
      id="mask0_18121_72217"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="37"
      height="43"
    >
      <ellipse cx="18.4365" cy="21.0821" rx="17.9365" ry="20.9185" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_18121_72217)">
      <path
        d="M30.6108 14.5853C30.8027 14.2494 31.2871 14.2494 31.479 14.5853L48.0327 43.5542C48.2232 43.8875 47.9825 44.3022 47.5986 44.3022H14.4913C14.1074 44.3022 13.8667 43.8875 14.0572 43.5542L30.6108 14.5853Z"
        fill="#DDF247"
        stroke="#4A7875"
        strokeWidth="3"
      />
    </g>
    <rect
      x="30.125"
      y="35.2563"
      width="12.3077"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 30.125 35.2563)"
      fill="#133C40"
    />
    <rect
      x="30.125"
      y="41.2803"
      width="3"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 30.125 41.2803)"
      fill="#133C40"
    />
  </svg>
)
